<template>
  <div>
    <Row>
      <Dropdown trigger="click" style="margin-left: 20px" placement="bottom-start" 
          :transfer="true"
          @on-click="click" @on-visible-change="this.visible_change">
        <a href="javascript:void(0)">
            {{drop_down_title}}
            <Icon type="ios-arrow-down" v-if="this.icon_flag"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem v-for="item in this.dropdown_item" :key="item.name" :name="item.index">{{ item.name }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Row>
  </div>
</template>
<script>
export default {
  name: "early_report_render_dropdown_view",
  data() {
    return {
      m_allow_msg:{},
      dropdown_item:[],
    }
  },
  props: {
    allow_msg:{
      type: [Array, Object],
      default:{}
    },
    drop_down_title:{
      type: String,
      default: "添加"
    },
    icon_flag: {
      type:Boolean,
      default: true
    },
    // 默认是预警状态展示页面的下拉框
    _type: {
      type:Number,
      default: 0
    }
  },
  methods:{
    visible_change(value) {
      if (value === true) {
        this.dropdown_item = this.get_v_for_index()
      }
    },
    click(index) {
      if (this._type == 0) {
        var value = this.m_allow_msg[index][0]
        this.$emit("dropdown_click", {        
          "mode":"ok",
          "id":value,
          "type":this._type
        })
      } else if (this._type == 1) {
        this.$emit("dropdown_click", {        
          "mode":"ok",
          "id":index,
          "type":this._type
        })
      }
    },
    get_v_for_index() {
      let v_for_index = []

      if (this._type === 0) {
        if (this.allow_msg === null) {
          v_for_index.push({"name":""})
          return v_for_index
        } else {
          this.m_allow_msg = JSON.parse(JSON.stringify(this.allow_msg))
          for (var i = 0; i < this.m_allow_msg.length; i++) {
            v_for_index.push(
              {name: "ID:" + this.m_allow_msg[i][0], index:i}
            )
          }
          return v_for_index
        }
      } else if (this._type === 1) {
        if (this.allow_msg === null) {
          return v_for_index
        } else {
          for (var key in this.allow_msg) {
            v_for_index.push({
              name: this.allow_msg[key][0], index:key
            })
          }
          v_for_index.sort(function(a, b){return Number(a.index) - Number(b.index)})
          return v_for_index
          // for (var i = 0; i < this.m_allow_msg.length; i++) {
          //   // "状态"0为待启动，1为正在运行
          //   var status = this.m_allow_msg[i][4]
          //   if (status == 0) {
          //     v_for_index.push(
          //       {name: "ID:" + this.m_allow_msg[i][0] + ", name:" + this.m_allow_msg[i][1], index:this.m_allow_msg[i][0]}
          //     )
          //   }
          // }
          // return v_for_index
        }
        
      }
    }
  },
  mounted: function() {
  },
  watch: {
    
  }
}
</script>
<style>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>